import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import localeES from "../utils/locale-es.json";
import {
  Datepicker,
  Basic,
  PrimaryButton,
  TableMobile,
} from "extranet-component-library";
import { useStores } from "../hooks/useStores";
import { parseHeadersTable } from "../utils/parsers";
import { Booking } from "../models";

interface BookingsProps {
  bookings: Array<any>;
}

const BookingsContent = ({ ...props }: BookingsProps) => {
  const { t } = useTranslation();
  const { moutebeStore } = useStores();
  const [showMore, setShowMore] = useState(false);
  const [bookingDates, setBookingDates] = useState([]);
  const [bookingCards, setBookingCards] = useState<Array<Booking>>([]);
  const cardsPerPage = 5;
  const ref = useRef(cardsPerPage);
  let arrayForHoldingCards: any = [];

  const loopWithSlice = (start: number, end: number) => {
    const slicedCards = props.bookings.slice(start, end);
    arrayForHoldingCards = [...arrayForHoldingCards, ...slicedCards];
    setBookingCards(arrayForHoldingCards);
    setShowMore(end < props.bookings.length);
  };

  useEffect(() => {
    loopWithSlice(0, cardsPerPage);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.bookings.length]);

  const handleShowMore = () => {
    loopWithSlice(0, ref.current + cardsPerPage);
    ref.current += cardsPerPage;
  };

  const onSearchBookings = () => {
    if (bookingDates.length > 0) {
      const start = new Date(bookingDates[0]).toISOString().split("T")[0];
      const end = new Date(bookingDates[1]).toISOString().split("T")[0];
      moutebeStore.getBookings(start, end);
    }
  };

  return (
    <>
      <div>
        <i>{t("select_dates")}</i>
      </div>
      <Datepicker
        locale={localeES}
        value={bookingDates}
        mode="range"
        labelButton={t("search")}
        placeholder={t("dates")}
        onSelectDate={(dates: any) => setBookingDates(dates)}
        onSearchDate={onSearchBookings}
      />
      <div className="desktop">
        {props.bookings.length ? (
          <Basic
            rows={10}
            items={props.bookings}
            headers={parseHeadersTable(
              props.bookings,
              [
                "date",
                "status",
                "tim",
                "bicycle",
                "reason",
                "child",
                "anul_reason",
                "ret_date",
              ],
              false
            )}
          />
        ) : (
          <div data-testid="no_bookings" className="no-items">
            {t("no_items")}
          </div>
        )}
      </div>
      <div className="wallet card">
        {bookingCards.length ? (
          bookingCards.map((item, i) => {
            return (
              <TableMobile
                key={i}
                style={{
                  background: i % 2 !== 0 ? "#F3F3F3" : "white",
                  width: "100%",
                  marginBottom: "1rem",
                }}
                content={
                  <div className="flex-container">
                    <div>
                      <div className="item">
                        <div className="header">{t("headers.date")}</div>
                        {item.date}
                      </div>
                      <div className="item">
                        <div className="header">{t("headers.status")}</div>
                        {item.status}
                      </div>
                      <div className="item">
                        <div className="header">{t("headers.reason")}</div>
                        {item.reason}
                      </div>
                    </div>
                    <div>
                      <div className="item">
                        <div className="header">{t("headers.tim")}</div>
                        {item.tim ? item.tim : "-"}
                      </div>
                      <div className="item">
                        <div className="header">{t("headers.bicycle")}</div>
                        {item.bicycle ? item.bicycle : "-"}
                      </div>
                      <div className="item">
                        <div className="header">{t("headers.child")}</div>
                        {item.child ? "Si" : "No"}
                      </div>
                    </div>
                  </div>
                }
                showArrow={false}
              />
            );
          })
        ) : (
          <div data-testid="no_b_cards" className="no-items">
            {t("no_items")}
          </div>
        )}
        {showMore ? (
          <div className="load-more">
            <PrimaryButton
              text={t("load_more")}
              onClick={() => handleShowMore()}
            />
          </div>
        ) : null}
      </div>
    </>
  );
};

export default BookingsContent;
